module.exports = __webpack_public_path__ + "static/media/truck-road-freight-transporting-goods-on-a-container.44b702e5.jpg";